import { combineReducers } from '@reduxjs/toolkit';

import leads from './leads';
import selectedCustomerId from './selectedCustomerId';

/**
 * @typedef {{
 *  leads: import('./leads').LeadsState,
 *  selectedCustomerId: import('./selectedCustomerId').SelectedCustomerIdState,
 * }} UIState
 */

export default combineReducers({
  leads,
  selectedCustomerId,
});
